import { cn } from '@lair-finance/util'

export const AssetItem = ({ className, icon, name, amount }: { className?: string; icon: React.ReactNode; name: string; amount: string }) => (
  <div className={cn('flex items-center justify-between gap-x-2 p-4 bg-greyscale-700 rounded-[8px]', className)}>
    <div className={'inline-flex items-center gap-x-2'}>
      {icon}
      <span className={'typo-label-3 md:typo-label-2 text-greyscale-300'}>{name}</span>
    </div>
    <strong className={'typo-label-2 md:typo-label-1 text-greyscale-100'}>{amount}</strong>
  </div>
)
